import { formatPrice } from '@/utils/currency';
import $ from 'jquery';
import Vue from 'vue';
import manager from '../manager';
import {getGoods} from '@/api/goods'
import { addCart } from '@/api/cart';
import { INTERFACE } from '@/utils/INTERFACE'
import { isApp,isEditorPage } from '@/utils/page';


manager.add('zgbGoods', {
	created() {
        try {
            var configData = JSON.parse($(this.dom).find(".configData").text())
        } catch (err) {
            console.warn('商品推荐数据解析错误')
            return
        }
        configData.goods=configData.goods||[]
		this.instance = new Vue({
            el: this.dom,
            data(){
                return {
                    list:[],
                    loading:false
                }
            },
            computed:{
                mixList(){
                    if(configData.mock){
                        return configData.goods
                    }
                    return this.list.map(it=>({
                        ...it,
                        link:isApp()?INTERFACE().item.app(it.id):INTERFACE().item.mob(it.id),
                        imgUrl:it.aliasImgUrl||it.imgUrl,
                        name:it.aliasName||it.name,
                        price:it.price?formatPrice(it.price):formatPrice(it.jdPrice),
                        jdPrice:it.jdPrice?formatPrice(it.jdPrice):''
                    }))
                }
            },
			mounted() {
                if(configData.mock){
                    return
                }
				this.fetchList()
			},
			methods: {
                addCart,
                formatPrice,
                async fetchList(){
                    this.loading=true
                    var skus=configData.goods.map(it=>it.id)
                    var _goods=configData.goods
                    var isEditor=isEditorPage()
                    var goods=await getGoods(skus,isEditor)
                    for (let i = 0; i < goods.length; i++) {
                        for (let j = 0; j < _goods.length; j++) {
                            if (goods[i].id == _goods[j].id) {
                                goods[i] = {
                                    ..._goods[j],
                                    ...goods[i],
                                }
                            }
                        }
                    }
                    this.list=goods
                    this.loading=false
                    $(window).trigger("scroll")
                }
			}
		})
	},
	destroyed() {
		if (this.instance) {
			this.instance.$destroy()
		}
	}
})

